/**
 * The single place in the app that reads `import.meta.env`.
 *
 * Every VITE_* variable is picked up here and re-exported through `env`, so a
 * renamed or newly added variable only has to be touched in this file (plus
 * .env / .env.development and the ImportMetaEnv typing in src/vite-env.d.ts).
 * Nothing else should reference `import.meta.env` directly.
 */
export const env = {
    identityUrl:     import.meta.env.VITE_IDENTITY_URL,
    profileApi:      import.meta.env.VITE_PROFILE_API,
    guestApi:        import.meta.env.VITE_GUEST_API,
    blobApi:         import.meta.env.VITE_BLOB_API,
    jobApi:          import.meta.env.VITE_JOB_API,
    jobPublicApi:    import.meta.env.VITE_JOBPUBLIC_API,
    notificationApi: import.meta.env.VITE_NOTIFICATION_API,
    aiApi:           import.meta.env.VITE_AI_API,
    clarityId:       import.meta.env.VITE_CLARITYID,
} as const

export const oAuthConstants = {
    oauth: env.identityUrl + "/connect/token",
    //clientId: "js",
    //clientSecret: "vlx5tsetgsvp2n81"
}

export const apiConstants = {
    baseUrl: env.profileApi + "/hr/",
    baseUrlApi: env.profileApi + "/api/",
    baseUrlOData: env.profileApi + "/odata/"
}

export const apiGuests = {
    baseUrl: env.guestApi + '/'
}

export const apiIdentity = {
    baseUrl: env.identityUrl + '/api/'
}

export const apiBlob = {
    baseUrl: env.blobApi + '/'
}

export const apiJob = {
    baseUrl: env.jobApi + '/'
}

export const apiJobLP = env.jobPublicApi + '/'

export const apiNotification = {
    baseUrl: env.notificationApi + '/',
    hubAdminUrl: env.notificationApi + '/hubadmin'
}
